let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("335Kh")).then(() => parcelRequire('4gFlY'));